import { css } from "@emotion/react";
import React from "react";
import { CSS_MQ } from "../../../../styles/breakpoints";
import { FONTS, fontSize } from "../../../../styles/fonts";
import { CSS_COLORS } from "../../../../styles/styles-css-variables";

export const ConsiderOptionHeadline: React.FC<{
  title: React.ReactNode;
  svgLink: string;
}> = props => {
  return (
    <div
      css={css`
        display: flex;
        gap: 30px;

        align-items: center;
      `}
    >
      <img
        alt=""
        src={props.svgLink}
        css={css`
          display: block;
          color: black;

          width: 48px;
          height: 48px;
          ${CSS_MQ.atLeastMd} {
            width: 64px;
            height: 64px;
          }
        `}
      />

      <span
        css={[
          FONTS.SwarovskiFutura500,
          fontSize.x2,
          css`
            color: ${CSS_COLORS.Black};

            text-transform: uppercase;
            text-align: center;

            display: flex;
            align-items: flex-end;
          `,
        ]}
      >
        {props.title}
      </span>
    </div>
  );
};
